<template>
  <div class='day atb-flex atb-flex-column'>
    <div class='header atb-flex atb-flex-items-center'>
      <div class='day-title'>
        <h2>{{this.detail.resWkName? this.detail.title + ' / ' + this.detail.resWkName: ''}}</h2>
        <span class="saveStatus">{{saveStatus}}</span>
      </div>
    </div>
    <div class='container atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList" @submit.native.prevent>
          <el-form-item label="分类">
            <el-select clearable v-model="searchParam.WorkClassify" placeholder="分类">
              <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成情况">
            <el-input v-model="searchParam.CompleteStatus" placeholder="完成情况" clearable></el-input>
            <!-- <el-select clearable v-model="searchParam.CompleteStatus" placeholder="完成情况">
              <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model="searchParam.KeyWord" placeholder="工作项"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item v-if="editStatus == 'edit'">
            <el-button type="primary" @click="showSubmit = true">提交</el-button>
          </el-form-item>
          <el-form-item v-if="editStatus == 'edit'">
            <el-button type="export" @click="exportExcel">导出</el-button>
          </el-form-item>
            <el-form-item v-if="editStatus == 'approve'">
            <el-button type="primary" @click="commit">反馈</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          class='atb-table header-table edit-table border-table'
          border='full'
          auto-resize
          resizable
          :data="tableData"
          ref="day"
          :merge-cells="mergeCells"
          :row-class-name="setRowClass"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @edit-actived="activeRow"
          :edit-rules="validRules"
        >
          <vxe-table-column field="workItemNo" title="NO." align="center" width="60">
            <template #default="scope">
              <template v-if="scope.rowIndex === 0">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandKpi" :class="[expandKpiStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandKpi">计划内工作</span>
                    <i v-throttle v-if='status === 0 && editStatus == "edit"' @click="addKpi" class="icon-add"></i>
                  </div>
                  <span v-throttle v-if='status === 0 && editStatus == "edit"' @click='addKpi(scope.row)'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + 1">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                 <div>
                   <i @click="expandNormal" :class="[expandNormalStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandNormal">计划外工作</span>
                    <i v-throttle v-if='status === 0 && editStatus == "edit"' @click="addNormal" class="icon-add"></i>
                 </div>
                 <span v-throttle v-if='status === 0 && editStatus == "edit"' @click='addNormal'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + 2">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                 <div>
                   <i @click="expandCreate" :class="[expandCreateStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandCreate">加班工作</span>
                    <i v-throttle v-if='status === 0 && editStatus == "edit"' @click="addCreate" class="icon-add"></i>
                 </div>
                 <span v-throttle v-if='status === 0 && editStatus == "edit"' @click='addCreate'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + 3">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                 <div>
                   <i @click="expandOther" :class="[expandOtherStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandOther">问题工作</span>
                    <i v-throttle v-if='status === 0 && editStatus == "edit"' @click="addOther" class="icon-add"></i>
                 </div>
                 <span v-throttle v-if='status === 0 && editStatus == "edit"' @click='addOther'>新增</span>
                </div>
              </template>
              <template v-else>
                <span v-if="scope.rowIndex <= kpiLength">{{scope.rowIndex}}</span>
                <span v-else-if="scope.rowIndex > kpiLength + 1 && scope.rowIndex <= normalLength + kpiLength + 2">{{scope.rowIndex - kpiLength - 1}}</span>
                <span v-else-if="scope.rowIndex > normalLength + kpiLength + 2 && scope.rowIndex <= normalLength + kpiLength + createLength + 3">{{scope.rowIndex - kpiLength - normalLength - 2}}</span>
                <span v-else>{{scope.rowIndex - kpiLength - createLength - normalLength - 3}}</span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="startTime" title="开始时间" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-time-picker format="HH:mm" value-format="HH:mm" v-model="row.startTime" placeholder="选择时间"></el-time-picker>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="endTime" title="结束时间" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-time-picker format="HH:mm" value-format="HH:mm" v-model="row.endTime" placeholder="选择时间"></el-time-picker>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项" :edit-render="{enabled: disabled, autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input :maxlength="$config.input.textareaMaxLength" type='textarea' :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.workItemContent"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="300" field="completeStatus" title="完成情况" :edit-render="{enabled: allowEdit, autofocus: '.el-input__inner'}">
            <!-- <template #default="{row}">
              <span v-if='row.completeStatus == 0'>计划</span>
              <span v-if='row.completeStatus == 10'>进行中</span>
              <span v-if='row.completeStatus == 20'>已完成</span>
              <span v-if='row.completeStatus == 30'>延迟</span>
              <span v-if='row.completeStatus == 40'>转移</span>
              <span v-if='row.completeStatus == 50'>暂停或关闭</span>
            </template> -->
            <template #edit="{ row }">
              <el-input :maxlength="$config.input.textareaMaxLength" type='textarea' :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.completeStatus"></el-input>
              <!-- <el-select v-model='scope.row.completeStatus' @change="$refs.day.updateStatus(scope)">
                <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select> -->
            </template>
          </vxe-table-column>
           <vxe-table-column width="80" field="resWkName" title="新增人" :edit-render="{autofocus: '.el-textarea__inner', enabled: false}">
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.resWkName"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed width='180' class-name='operation'>
            <template #default="scope">
              <div v-if='(scope.row.status === 0 || scope.row.status === 30 || scope.row.status === 100) && editStatus == "edit"'>
                <el-tooltip class='item' effect='dark' content='保存' placement="bottom">
                  <i class='icon-baocun' v-throttle @click.stop='saveToday(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='复制' placement="bottom">
                  <i class='icon-copy' v-throttle @click.stop='copyData(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                  <i class='icon-close delete' v-throttle @click.stop='deleteData(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip v-if="scope.row.id" class='item' effect='dark' content='切换分类' placement="bottom">
                  <i class='icon-move' @click.stop='move(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
         <vxe-table
           class="operation-table atb-table edit-table"
           :show-header="false"
           border='full'
           auto-resize
           resizable
           ref="judge"
           :data="operation"
           :row-class-name="setOperationClass"
           :merge-cells="mergeOperation"
           :edit-config="{trigger: 'click', mode: 'cell',  activeMethod: activeCellMethod}"
           @edit-disabled="editDisabledEvent"
           @edit-closed="judgeEditClosed"
           @edit-actived="judgeEditActived">
           <vxe-table-column field="address" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="scope">
              <template v-if="scope.rowIndex === 0">
                 <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>本日总结</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === 2 && auth === 0">
                 <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>今日自评</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === 3 && auth === 0">
                <el-checkbox-group :disabled="status === 10 || editStatus !== 'edit'" size="medium" v-model="selfEvaluation" @change="changeType">
                  <el-checkbox label="A"></el-checkbox>
                  <el-checkbox label="B"></el-checkbox>
                  <el-checkbox label="C"></el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-else-if="scope.rowIndex === 2 && auth === 1">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>领导评定</span>
                </div>
              </template>
               <template v-else-if="scope.rowIndex === 3 && auth === 1">
                <el-checkbox-group size="medium" v-model="bossJudge">
                  <el-checkbox label="A"></el-checkbox>
                  <el-checkbox label="B"></el-checkbox>
                  <el-checkbox label="C"></el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-else-if="scope.rowIndex === 4">
                 <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                   <div>
                    <span>明日工作计划</span>
                    <i v-throttle v-if="status === 0 && editStatus == 'edit'" @click="addTomorrow" class="icon-add"></i>
                   </div>
                   <span v-throttle @click='addTomorrow' v-if="status === 0 && editStatus == 'edit'">新增</span>
                </div>
              </template>
              <template v-else>
                <span>{{summary}}</span>
              </template>
            </template>
            <template #edit="scope">
              <el-input :maxlength="$config.input.textareaMaxLength" type='textarea' class="summaryText" :autosize="{ maxRows: 8 }" placeholder="请输入今日总结" v-model="summary"></el-input>
            </template>
          </vxe-table-column>
           <vxe-table-column field="name" title="Name">
            <template #default="scope">
              <template v-if="scope.rowIndex === 2">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>今日自评</span>
                </div>
              </template>
            </template>
           </vxe-table-column>
           <vxe-table-column field="sex" title="Sex" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="scope">
              <template v-if="scope.rowIndex === 2 && auth === 0">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>自评原因</span>
                </div>
              </template>
               <template v-else-if="scope.rowIndex === 2 && auth === 1">
                <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>评定原因</span>
                </div>
              </template>
              <template v-else>
                <span>{{selfEvaluationReason}}</span>
              </template>
            </template>
             <template #edit="scope">
               <template v-if="scope.rowIndex === 3 && auth === 0">
                 <el-input :maxlength="$config.input.textareaMaxLength" type='textarea' :autosize="{ maxRows: 8 }" placeholder="请输入自评原因" v-model="selfEvaluationReason"></el-input>
               </template>
               <template v-if="scope.rowIndex === 3 && auth === 1">
                 <el-input type='textarea' autosize placeholder="请输入内容" v-model="scope.row.id"></el-input>
               </template>
             </template>
           </vxe-table-column>
          <vxe-table-column field="age" title="Age" class-name='operation'></vxe-table-column>
        </vxe-table>
        <vxe-table
          class="operation-table atb-table edit-table"
          :show-header="false"
          border='full'
          auto-resize
          resizable
          ref="tomorrow"
          :data="tomorrow"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: tomorrowActived}"
          @edit-closed="editTomorrowClosed"
          @edit-actived="editTomorrowActived">
          <vxe-table-column field="workItemNo" align="center" width="60">
            <template #default="scope">
              <span>{{scope.rowIndex + 1}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="scope">
              <template>
                 <el-input :maxlength="$config.input.textareaMaxLength" type='textarea' :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="scope.row.workItemContent"></el-input>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="age" title="Age" width="180" class-name="operation">
             <template #default="scope">
              <div  v-if="editStatus == 'edit'">
                <el-tooltip class='item' effect='dark' content='保存' placement="bottom">
                  <i class='icon-baocun' v-throttle @click.stop='savePlan(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='复制' placement="bottom">
                  <i class='icon-copy' v-throttle @click.stop='copyTomorrow(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                  <i class='icon-close delete' v-throttle @click.stop='deleteTomorrow(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-table
          class="operation-table atb-table edit-table"
          :show-header="false"
          border='full'
          auto-resize
          resizable
          :merge-cells="mergeFeedback"
          :data="feedback"
          :row-class-name="setOperationClass"
          :edit-config="{trigger: 'click', mode: 'row'}"
          v-if="detail.msgId"
          ref="feedback">
          <vxe-table-column field="workItemNo">
            <template #default="scope">
              <template v-if="scope.rowIndex === 0">
                 <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>领导反馈</span>
                </div>
              </template>
              <template v-else>
                 <div>{{detail.superiorEvaluationReason}}</div>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent">
            <template #default="scope">
              {{ detail.superiorEvaluationReason }}
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <el-dialog title="转移工作分类" :visible.sync="showHandle" width="500px">
      <div class="content">
        <el-radio-group v-model="classify">
          <el-radio-button :key="item.label + item.value" v-for="item in classifyList" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmClassify">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交" :visible.sync="showSubmit" width="260px">
      <div class="content sub-content">
        <h2>确定要提交吗?</h2>
        <p>提交后无法撤回</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSubmit = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="意见反馈" :visible.sync="showCommit" width="500px" @close="closeCommit">
      <div class="content">
      <el-input
        type="textarea"
        :autosize="{ minRows: 5 }"
        placeholder="请输入内容"
        v-model="comment">
      </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmCommit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCommit = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash';
  import routeMixin from '@/mixins/route.mixin'
  export default {
    name: "index",
    inject: ["reload"],
    mixins: [routeMixin],
    data() {
      const startTime = ({cellValue, row}) => {
        if (!cellValue && (row.status===0)) {
          return new Error('开始时间必填')
        }else{
          if(row.endTime&&(row.status===0)){
            const currDate=this.detail.date.split('T')[0];
             if(XEUtils.timestamp(currDate + ' ' + cellValue + ":00","yyyy-MM-dd HH:mm:ss")>XEUtils.timestamp(currDate + ' ' + row.endTime + ":00","yyyy-MM-dd HH:mm:ss")){
                return new Error('开始时间不能大于结束时间')
             }
          }
        }
      }
      const endTime = ({cellValue, row}) => {
        if (!cellValue && (row.status===0)) {
          return new Error('结束时间必填')
        }else{
          if(row.startTime&&(row.status===0)){
            const currDate=this.detail.date.split('T')[0];
             if(XEUtils.timestamp(currDate + ' ' + cellValue + ":00","yyyy-MM-dd HH:mm:ss")<XEUtils.timestamp(currDate + ' ' + row.startTime + ":00","yyyy-MM-dd HH:mm:ss")){
                return new Error('结束时间不能小于开始时间')
             }
          }
        }
      }
      const workItemContent = ({cellValue, row}) => {
        if (!cellValue && (row.status===0)) {
          return new Error('工作项必填')
        }
      }
      const completeStatus = ({cellValue, row}) => {
        if (!cellValue && (row.status===0)) {
          return new Error('完成情况必填')
        }
      }
      return {
        validRules: {
          startTime: [
            { required: true, validator: startTime},
          ],
          endTime: [
            { required: true, validator: endTime }
          ],
          workItemContent: [
            { required: true, validator: workItemContent }
          ],
          completeStatus: [
            { required: true, validator: completeStatus }
          ]
        },
        workId: '',
        XEUtils: XEUtils,
        activeName: 'second',
        currentTab: 0,
        showCommit: false,
        showHandle: false,
        showSubmit: false,
        handleDelete: true,
        tabList: [
          {
            label: '常规工作',
            id: 0,
          },
          {
            label: '例行工作',
            id: 1,
          },
        ],
        searchParam: {
          WorkItemCategory: null,
          WorkClassify: null,
          KeyWord: null,
          CompleteStatus: null
        },

        disabled: true,
        allowEdit: true,
        mergeCells: [
          {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          {row: 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          {row: 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          {row: 3, col: 0, rowspan: 1, colspan: this.tableColumnLength}
        ],
        mergeOperation: [
          {row: 0, col: 0, rowspan: 1, colspan: 4},
          {row: 1, col: 0, rowspan: 1, colspan: 4},
          {row: 2, col: 0, rowspan: 1, colspan: 2},
          {row: 2, col: 2, rowspan: 1, colspan: 2},
          {row: 3, col: 0, rowspan: 1, colspan: 2},
          {row: 3, col: 2, rowspan: 1, colspan: 2},
          {row: 4, col: 0, rowspan: 1, colspan: 4},
        ],
        mergeFeedback: [
          {row: 0, col: 0, rowspan: 1, colspan: 2},
          {row: 1, col: 0, rowspan: 1, colspan: 2},
        ],
        result: {},
        kpi: [],
        normal: [],
        create: [],
        other: [],
        record: {
          workId: '',
          workClassify: 0,
          workItemNo: "",
          startTime: "",
          endTime: "",
          resWkNo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : '',
          resWkName: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : '',
          completeStatus: '',
          workItemContent: '',
          creatorId: sessionStorage.getItem("LOGIN_NAME"),
          status: 100,
          creationTimeSapn: ''
        },
        classifyList: [
          {label: '计划内工作', value: 0},
          {label: '计划外工作', value: 10},
          {label: '加班工作', value: 20},
          {label: '问题工作', value: 30},
        ],
        categoryList: [
          {value: '前端'},
          {value: '后端'}
        ],
        completeList: [
          {label: '计划', value: 0},
          {label: '进行中', value: 10},
          {label: '已完成', value: 20},
          {label: '延迟', value: 30},
          {label: '转移', value: 40},
          {label: '暂停或关闭', value: 50},
        ],
        importantList: [
          {label: '否', value: 0},
          {label: '是', value: 1},
        ],
        programList: [
          {"value": "A2000plus"},
          {"value": "A1000plus"},
          {"value": "远程项目"},
        ],
        unHandleList: [],
        handledList: [],
        allChecked: false,
        programData: [
          {id: 10001, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10002, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10003, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10004, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10005, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'}
        ],
        operation: [
          {id: "10002", name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou'},
          {id: "10003", name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou'},
          {id: "10004", name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou'},
          {id: "10005", name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou'},
          {id: "10006", name: 'Test2', role: 'Test', sex: 'Women', age: 22, address: 'Guangzhou'},
        ],
        feedback:[
          {},{}
        ],
        tomorrow: [],
        status: 0,
        detail: {},
        selfJudge: [],
        bossJudge: [],
        auth: 0,
        selfEvaluation: [],
        selfEvaluationReason: '',
        summary: '',
        comment: '',
        classify: '',
        cloneTableData:{
          tableData: [],
          tomorrow: [],
          selfEvaluation: '',
          selfEvaluationReason: '',
          summary: ''
        },
        timer: null,
        planTimer: null,
        tableColumn: [],
        row: {},
        rowIndex: 0,
        expandKpiStatus: true,
        expandNormalStatus: true,
        expandCreateStatus: true,
        expandOtherStatus: true,
        editStatus: 'edit',
        that:this,
        saveStatus:'',
        timeoutSave:'',
        timeoutAutoSave:'',
        timeoutSavePlan:'',
        timeoutAutoSavePlan:'',
        timeoutSaveJudge:'',
        timeoutAutoSaveJudge:'',
        cloneKpi: [],
        cloneNormal: [],
        cloneCreate: [],
        cloneOther: [],
        autoSaving: false, //是否在自动保存中
        isPreventSave: false, //是否阻止了自动保存
      }
    },
    computed: {
      kpiLength() { //kpi数据长度 动态增加数据使用
        return this.kpi.length;
      },
      normalLength() {
        return this.normal.length;
      },
      createLength() {
        return this.create.length;
      },
      otherLength() {
        return this.other.length;
      },
      tableData() {
        return [{}, ...this.kpi, {}, ...this.normal, {}, ...this.create, {}, ...this.other];
      },
      tableColumnLength() {
        return this.tableColumn.filter(val => val.visible !== false).length;
      }
    },
    created() {
      this.workId = this.$route.query.id || '';
      this.status = Number(this.$route.query.status) || 0;
      this.record.workId = this.workId;
      this.editStatus = this.$route.query.editStatus || '';
      this.getList();
    },
    mounted() {
      document.addEventListener('keydown', this.saveContent);
      this.$nextTick(() => {
        this.tableColumn = this.$refs.day.getColumns();
        if (!this.editStatus) {
          let val = this.tableColumn.find(val => val.title == "操作");
          val.visible = false;
          this.$refs.day && this.$refs.day.refreshColumn();
        }
      });
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.saveContent)
    },
    methods: {
      closeCommit() {
        this.comment = "";
      },
      approveText(e) {
        this.comment = e;
      },
      exportExcel() {
        let param = Object.assign({WorkId: this.workId})
        this.$ajax.get(this.$api.day.DayWorkDetail.export, param, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = Object.keys(this.detail).length? this.detail.title + '详情' + "(" + this.detail.resWkName + ")":'日计划';
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      saveContent(e) {
        let key = window.event.keyCode ? window.event.keyCode : window.event.which
        if (key === 83 && e.ctrlKey) {
          this.save();
          e.preventDefault()
        }
      },
      changeType() {
        if (this.selfEvaluation.length > 1) {
          this.selfEvaluation.splice(0, 1);
          this.cloneTableData.selfEvaluation = _.cloneDeep(this.selfEvaluation);
          this.saveJudge();
        }
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
      },
      getList() {
        let param = Object.assign({WorkId: this.workId}, this.searchParam, this.page)
        this.$ajax.get(this.$api.day.DayWorkDetail.list, param).then((res) => {
          this.filterTableData(res.data.dayWorkDetailDto.detailDtoList);
          this.tomorrow = res.data.dayWorkDetailDto.planDtoList || [];
          this.selfEvaluation = [res.data.dayWorkDetailDto.selfEvaluation];
          this.selfEvaluationReason = res.data.dayWorkDetailDto.selfEvaluationReason;
          this.summary = res.data.dayWorkDetailDto.summary;
          this.detail = res.data.dayWorkDto;
          this.status = this.detail.status;
          this.cloneTableData.selfEvaluation = _.clone(this.selfEvaluation);
          if (res.data.dayWorkDetailDto.detailDtoList.length === 0) {
            this.tableData = [{}, {}, {}, {}];
          }
        });
      },
      filterTableData(tableData) {
        this.kpi = tableData.filter(val => val.workClassify == 0);
        this.normal = tableData.filter(val => val.workClassify == 10);
        this.create = tableData.filter(val => val.workClassify == 20);
        this.other = tableData.filter(val => val.workClassify == 30);
      },
      async addKpi() {
        if (!this.expandKpiStatus) {
          this.expandKpiStatus = true;
          this.kpi = _.cloneDeep(this.cloneKpi);
          this.cloneKpi = [];
        }
        if (this.kpiLength >= this.$config.workItemLength.day.kpi) {
          this.$message.error(`最多可添加${this.$config.workItemLength.day.kpi}条数据`);
          return false;
        }
        const $table = this.$refs.day;
        let kpiItem = _.cloneDeep(this.record);
        kpiItem.creationTimeSapn = new Date().getTime();
        this.kpi.push(kpiItem);
        await $table.setActiveRow(this.tableData[this.kpiLength]);
      },
      async addNormal() {
        if (!this.expandNormalStatus) {
          this.expandNormalStatus = true;
          this.normal = _.cloneDeep(this.cloneNormal);
          this.cloneNormal = [];
        }
        if (this.normalLength >= this.$config.workItemLength.day.normal) {
          this.$message.error(`最多可添加${this.$config.workItemLength.day.normal}条数据`);
          return false;
        }
        const $table = this.$refs.day;
        let normalItem = _.cloneDeep(this.record);
        normalItem.workClassify = 10;
        normalItem.creationTimeSapn = new Date().getTime();
        this.normal.push(normalItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.normalLength]);
      },
      async addCreate() {
        if (!this.expandCreateStatus) {
          this.expandCreateStatus = true;
          this.create = _.cloneDeep(this.cloneCreate);
          this.cloneCreate = [];
        }
        if (this.createLength >= this.$config.workItemLength.day.create) {
          this.$message.error(`最多可添加${this.$config.workItemLength.day.create}条数据`);
          return false;
        }
        const $table = this.$refs.day;
        let createItem = _.cloneDeep(this.record);
        createItem.workClassify = 20;
        createItem.creationTimeSapn = new Date().getTime();
        this.create.push(createItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.normalLength + this.createLength]);
      },
      async addOther() {
        if (!this.expandOtherStatus) {
          this.expandOtherStatus = true;
          this.other = _.cloneDeep(this.cloneOther);
          this.cloneOther = [];
        }
        if (this.otherLength >= this.$config.workItemLength.day.other) {
          this.$message.error(`最多可添加${this.$config.workItemLength.day.other}条数据`);
          return false;
        }
        const $table = this.$refs.day;
        let otherItem = _.cloneDeep(this.record);
        otherItem.creationTimeSapn = new Date().getTime();
        otherItem.workClassify = 30;
        this.other.push(otherItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 3 + this.normalLength + this.createLength + this.otherLength]);
      },
      async addTomorrow() {
        const record = {
          workId: this.workId,
          workItemNo: '',
          workItemContent: '',
          resWkName: JSON.parse(sessionStorage.getItem("userInfo")).wkName,
          resWkNo: JSON.parse(sessionStorage.getItem("userInfo")).wkNo,
        };
        let item = _.cloneDeep(record);
        const $table = this.$refs.tomorrow;
        item.creationTimeSapn = new Date().getTime();
        this.tomorrow.push(item);
        await $table.setActiveRow(this.tomorrow[this.tomorrow.length - 1]);
      },
      setRowClass({rowIndex}) {
        if (rowIndex == 0 || rowIndex == this.kpiLength + 1 || rowIndex == this.kpiLength + this.normalLength + 2 || rowIndex == this.kpiLength + this.normalLength + this.createLength + 3) {
          return 'main-row';
        }
      },
      setOperationClass({rowIndex}) {
        if (rowIndex === 0 || rowIndex === 2 || rowIndex === 4) {
          return 'main-row';
        }
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format)
      },
      editClosed({row, rowIndex}) {
        this.row = {};
        this.rowIndex = 0;
        this.allowEdit = true;
        this.disabled = true;
        clearInterval(this.timer);
        if (rowIndex !== -1) {
          if (this.status === 0 || this.status === 30) {
            this.saveToday(row, rowIndex);
          }
        }
      },
      activeRow({row, rowIndex}) {
        this.row = row;
        this.rowIndex = rowIndex;
        if (this.status !== 10 && this.editStatus == 'edit') {
          this.timer = setInterval(() => {
            this.autoSaveToday(row, rowIndex);
          }, 10000)
        }
      },
      saveToday(row, index) {
        // if(this.cloneTableData.tableData[index].workItemContent.length < this.$config.input.textareaMinLength
        // ) {
        //   this.$message.error("工作项内容最少输入10个字符");
        //   return false
        // }
        if (this.autoSaving) {
          this.isPreventSave = true;
        } else {
          this.isPreventSave = false;
          this.$ajax.post(this.$api.day.DayWorkDetail.detail, this.tableData[index], {noLoading:true}).then((res) => {
            const item = res.data;
            if (!row.id) {
              this.tableData.forEach(val => {
                if (row.creationTimeSapn === val.creationTimeSapn) {
                  val.id = item.id;
                  val.status = item.status;
                }
              })
            }
            // if (item.workClassify === 0) {
            //   if (this.expandKpiStatus) {
            //     this.kpi.splice(index - 1, 1, item);
            //   } else {
            //     this.cloneKpi.splice(index - 1, 1, item);
            //   }
            // }else if (item.workClassify === 10){
            //   if (this.expandNormalStatus) {
            //     this.normal.splice(index - this.kpiLength - 2, 1, item);
            //   } else {
            //     this.cloneNormal.splice(index - this.kpiLength - 2, 1, item);
            //   }
            // }else if (item.workClassify === 20) {
            //   if (this.expandCreateStatus) {
            //     this.create.splice(index - this.kpiLength - this.normalLength - 3, 1, item);
            //   } else {
            //     this.cloneCreate.splice(index - this.kpiLength - this.normalLength - 3, 1, item);
            //   }
            // } else if (item.workClassify === 30) {
            //   if (this.expandOtherStatus) {
            //     this.other.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1, item);
            //   } else {
            //     this.cloneOther.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1, item);
            //   }
            // }
            // if (index <= this.kpiLength) {
            //   this.kpi.splice(index - 1, 1, item);
            // } else if (index >= this.kpiLength + 1 && index < this.normalLength + this.kpiLength + 2) {
            //   this.normal.splice(index - this.kpiLength - 2, 1, item);
            // } else if (index >= this.normalLength + this.kpiLength + 2 && index < this.normalLength + this.kpiLength + this.createLength + 3) {
            //   this.create.splice(index - this.kpiLength - this.normalLength - 3, 1, item);
            // } else {
            //   this.other.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1, item);
            // }
            // this.filterTableData(this.tableData);
            this.saveStatus="已保存";
            this.timeoutSave&&clearTimeout(timeoutSave);
            const timeoutSave=setTimeout(()=>{
              this.saveStatus="";
            },1000,this);
            // this.$message.success('保存成功');
          });
        }
      },
      autoSaveToday(row, index) {
        this.autoSaving = true;
        this.$ajax.post(this.$api.day.DayWorkDetail.detail, this.tableData[index], {noLoading:true}).then((res) => {
          const item = res.data;
          if (!row.id) {
            this.tableData.forEach(val => {
              if (row.creationTimeSapn === val.creationTimeSapn) {
                val.id = item.id;
                val.status = item.status;
              }
            })
          }
          this.saveStatus="已保存";
          this.timeoutAutoSave&&clearTimeout(timeoutAutoSave);
          const timeoutAutoSave=setTimeout(()=>{
            this.saveStatus="";
          },1000,this);
          this.autoSaving = false;
          if(this.isPreventSave) {
            this.saveToday(row, index);
          }
          // this.$message.success('保存成功');
        }).catch(() => {
          this.autoSaving = false;
        });
      },
      save() {
        const arr = this.tableData.filter(val => val.workId !== undefined);
        this.$ajax.post(this.$api.day.DayWorkDetail.addAll, {
          workId: this.workId,
          planDtoList: this.cloneTableData.tomorrow,
          detailDtoList: arr,
          selfEvaluation: this.cloneTableData.selfEvaluation.join(''),
          selfEvaluationReason: this.cloneTableData.selfEvaluationReason,
          summary: this.cloneTableData.summary
        }, {noLoading:true}).then((res) => {
          const item = res.data;
          this.filterTableData(item.detailDtoList);
          this.tomorrow = item.planDtoList || [];
          this.selfEvaluation = [item.selfEvaluation];
          this.selfEvaluationReason = item.selfEvaluationReason;
          this.summary = item.summary;
          this.$message.success('保存成功');
        });
      },
      //通过现有表格的index获取真实数据的index
      realIndex(rowIndex) {
        if (rowIndex <= this.kpiLength) {
          return rowIndex - 1;
        }else if (rowIndex > this.kpiLength + 1 && rowIndex <= this.normalLength + this.kpiLength + 2) {
          return rowIndex - 2;
        }else if (rowIndex > this.normalLength + this.kpiLength + 2 && rowIndex <= this.normalLength + this.kpiLength + this.createLength + 3) {
          return rowIndex - 3;
        }else {
          return rowIndex - 4;
        }
      },
      savePlan(row, index) {
        // if(this.cloneTableData.tomorrow[index].workItemContent.length < this.$config.input.textareaMinLength
        // ) {
        //   this.$message.error("工作项,目标内容最少输入10个字符");
        //   return false
        // }
        this.$ajax.post(this.$api.day.DayWorkDetail.createPlan, this.tomorrow[index], {noLoading:true}).then((res) => {
          const item = res.data;
          if (!row.id) {
            this.tomorrow.forEach(val => {
              if (row.creationTimeSapn === val.creationTimeSapn) {
                val.id = item.id;
                val.status = item.status;
              }
            })
          }
          this.saveStatus="已保存";
          this.timeoutSavePlan&&clearTimeout(timeoutSavePlan);
          const timeoutSavePlan=setTimeout(()=>{
            this.saveStatus="";
          },1000,this);
          // this.$message.success('保存成功');
        });
      },
      autoSavePlan(row, index) {
        this.$ajax.post(this.$api.day.DayWorkDetail.createPlan, this.tomorrow[index], {noLoading:true}).then((res) => {
          const item = res.data;
          if (!row.id) {
            this.tomorrow.forEach(val => {
              if (row.creationTimeSapn === val.creationTimeSapn) {
                val.id = item.id;
                val.status = item.status;
              }
            })
          }
          this.saveStatus="已保存";
          this.timeoutAutoSavePlan&&clearTimeout(timeoutAutoSavePlan);
          const timeoutAutoSavePlan=setTimeout(()=>{
            this.saveStatus="";
          },1000,this);
          // this.$message.success('保存成功');
        });
      },
      editTomorrowClosed({row, rowIndex}) {
        console.log(row, rowIndex);
        this.row = {};
        this.rowIndex = 0;
        clearInterval(this.planTimer);
        if (rowIndex !== -1) {
          this.savePlan(row, rowIndex);
        }
      },
      editTomorrowActived({row, rowIndex}) {
        this.row = row;
        this.rowIndex = rowIndex;
        if (this.status !== 10 && this.editStatus === 'edit') {
          this.planTimer = setInterval(() => {
            this.autoSavePlan(row, rowIndex);
          }, 10000)
        }
      },
      saveJudge() {
        this.$ajax.put(this.$api.day.dayWork.selfEvaluation, {
          workId: this.workId,
          selfEvaluation: this.cloneTableData.selfEvaluation.join(''),
          selfEvaluationReason: this.cloneTableData.selfEvaluationReason,
          summary: this.cloneTableData.summary
        }, {noLoading:true}).then((res) => {
          const item = res.data;
          this.summary = item.summary;
          this.selfEvaluation = [item.selfEvaluation];
          this.selfEvaluationReason = item.selfEvaluationReason;
          this.saveStatus="已保存";
          this.timeoutSaveJudge&&clearTimeout(timeoutSaveJudge);
          const timeoutSaveJudge=setTimeout(()=>{
            this.saveStatus="";
          },1000,this);
          // this.$message.success('保存成功');
        });
      },
      autoSaveJudge() {
        this.$ajax.put(this.$api.day.dayWork.selfEvaluation, {
          workId: this.workId,
          selfEvaluation: this.cloneTableData.selfEvaluation.join(''),
          selfEvaluationReason: this.cloneTableData.selfEvaluationReason,
          summary: this.cloneTableData.summary
        }, {noLoading:true}).then((res) => {
          const item = res.data;
          this.cloneTableData.summary = item.summary;
          this.cloneTableData.selfEvaluation = [item.selfEvaluation];
          this.cloneTableData.selfEvaluationReason = item.selfEvaluationReason;
          this.saveStatus="已保存";
          this.timeoutAutoSaveJudge&&clearTimeout(timeoutAutoSaveJudge);
          const timeoutAutoSaveJudge=setTimeout(()=>{
            this.saveStatus="";
          },1000,this);
          // this.$message.success('保存成功');
        });
      },
      judgeEditClosed() {
        this.saveJudge();
        clearInterval(this.timer);
      },
      judgeEditActived() {
        if (this.status !== 10 && this.editStatus == 'edit') {
          this.timer = setInterval(() => {
            this.autoSaveJudge();
          }, 10000)
        }
      },
      editDisabledEvent() {
        this.$refs.judge.clearActived();
      },
      querySearch(queryString, cb) {
        let programList = this.programList;
        // 调用 callback 返回建议列表的数据
        cb(programList);
      },
      async copyData(row, index) {
        const $table = this.$refs.day;
        const item = _.cloneDeep(row);
        delete item._XID;
        delete item.id;
        item.status = 100;
        item.source = 0;
        item.creationTimeSapn = new Date().getTime();
        let length = 0;
        if (index <= this.kpiLength) {
          if (this.kpiLength >= this.$config.workItemLength.day.kpi) {
            this.$message.error(`最多可添加${this.$config.workItemLength.day.kpi}条数据`);
            return false;
          }
          this.kpi.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength]);
          length = this.kpiLength;
        } else if (index > this.kpiLength + 1 && index <= this.normalLength + this.kpiLength + 2) {
          if (this.normalLength >= this.$config.workItemLength.day.normal) {
            this.$message.error(`最多可添加${this.$config.workItemLength.day.normal}条数据`);
            return false;
          }
          this.normal.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.normalLength]);
          length = this.kpiLength + this.normalLength + 1;
        } else if (index > this.normalLength + this.kpiLength + 2 && index <= this.normalLength + this.kpiLength + this.createLength + 3) {
          if (this.createLength >= this.$config.workItemLength.day.create) {
            this.$message.error(`最多可添加${this.$config.workItemLength.day.create}条数据`);
            return false;
          }
          this.create.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.normalLength + this.createLength]);
          length = this.kpiLength + 2 + this.normalLength + this.createLength;
        } else {
          if (this.otherLength >= this.$config.workItemLength.day.other) {
            this.$message.error(`最多可添加${this.$config.workItemLength.day.other}条数据`);
            return false;
          }
          this.other.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 3 + this.normalLength + this.createLength + this.otherLength]);
          length = this.kpiLength + 3 + this.normalLength + this.createLength + this.otherLength;
        }
        // this.autoSaveToday(item, length);
      },
      deleteData(row, index) {
        if (this.tableData[index].id) {
          this.$ajax.delete(this.$api.day.DayWorkDetail.detail + '/' + this.tableData[index].id).then(() => {
            const item = row;
            if (item.workClassify === 0) {
              _.remove(this.kpi, t => t.id == item.id);
              this.kpi.splice(0,0);
              // this.kpi = this.kpi.filter(t => t.id == item.id);
            }else if (item.workClassify === 10){
              _.remove(this.normal, t => t.id == item.id);
              this.normal.splice(0,0);
            }else if (item.workClassify === 20) {
              _.remove(this.create, t => t.id == item.id);
              this.create.splice(0,0);
            } else if (item.workClassify === 30) {
              _.remove(this.other, t => t.id == item.id);
              this.other.splice(0,0);
            }
            // if (index <= this.kpiLength) {
            //   this.kpi.splice(index - 1, 1);
            // } else if (index > this.kpiLength + 1 && index <= this.normalLength + this.kpiLength + 2) {
            //   this.normal.splice(index - this.kpiLength - 2, 1);
            // } else if (index > this.normalLength + this.kpiLength + 2 && index <= this.normalLength + this.kpiLength + this.createLength + 3) {
            //   this.create.splice(index - this.kpiLength - this.normalLength - 3, 1);
            // } else {
            //   this.other.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1);
            // }
            clearInterval(this.timer);
            this.$message.success('删除成功');
          });
        }else {
          if (index <= this.kpiLength) {
            this.kpi.splice(index - 1, 1);
          } else if (index > this.kpiLength + 1 && index <= this.normalLength + this.kpiLength + 2) {
            this.normal.splice(index - this.kpiLength - 2, 1);
          } else if (index > this.normalLength + this.kpiLength + 2 && index <= this.normalLength + this.kpiLength + this.createLength + 3) {
            this.create.splice(index - this.kpiLength - this.normalLength - 3, 1);
          } else {
            this.other.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1);
          }
          clearInterval(this.timer);
          this.$message.success('删除成功');
        }
      },
      copyTomorrow(row, index) {
        const item = _.cloneDeep(row);
        delete item._XID;
        delete item.id;
        item.status = 100;
        item.creationTimeSapn = new Date().getTime();
        this.tomorrow.push(item);
        const $table = this.$refs.tomorrow;
        $table.setActiveRow(this.tomorrow[this.tomorrow.length - 1]);
        // this.$nextTick(() => {
        //   this.autoSavePlan(item, this.tomorrow.length - 1);
        // });
      },
      deleteTomorrow(row, index) {
        if (this.tomorrow[index].id) {
          this.$ajax.delete(this.$api.day.DayWorkDetail.deletePlan + '/' + this.tomorrow[index].id).then(() => {
            _.remove(this.tomorrow, t => t.id == row.id);
            this.tomorrow.splice(0,0);
            clearInterval(this.planTimer);
            this.$message.success('删除成功');
          });
        }else {
          this.tomorrow.splice(index, 1);
          clearInterval(this.planTimer);
          this.$message.success('删除成功');
        }
      },
      getAllTableData() {
        //获取所有工作项的数据
        let relResult = [];
        if (this.cloneKpi.length) {
          relResult = relResult.concat(this.cloneKpi);
        }else {
          relResult = relResult.concat(this.kpi);
        }
        if (this.cloneNormal.length) {
          relResult = relResult.concat(this.cloneNormal);
        }else {
          relResult = relResult.concat(this.normal);
        }
        if (this.cloneCreate.length) {
          relResult = relResult.concat(this.cloneCreate);
        }else {
          relResult = relResult.concat(this.create);
        }
        if (this.cloneOther.length) {
          relResult = relResult.concat(this.cloneOther);
        }else {
          relResult = relResult.concat(this.other);
        }
        return relResult;
      },
      submit() {
        clearInterval(this.timer);
        clearInterval(this.planTimer);
        let trueData = this.getAllTableData();
        this.showSubmit = false;
        if(trueData.length===0){
          this.$message.warning('请填写工作项后再提交');
        }else{
          this.expandAll();
          this.$nextTick(async ()=> {
            const $table = this.$refs.day;
            const errMap = await $table.validate(true).catch(errMap => errMap)
            if (errMap) {
              const msgList = []
              Object.values(errMap).forEach(errList => {
                errList.forEach(params => {
                  const {rowIndex, column, rules} = params
                  rules.forEach(rule => {
                    msgList.push(`${column.title} 校验错误：${rule.message}`)
                  })
                })
              })
              this.$message({
                type: 'error',
                message: msgList.join()
              })
            } else {
              if (_.trim(this.summary) == '') {
                this.$message({
                  type: 'error',
                  message: "请填写总结"
                });
                return false;
              } else if (this.selfEvaluation[0] == '') {
                this.$message({
                  type: 'error',
                  message: "请选择自评"
                });
                return false;
              } else if (_.trim(this.selfEvaluationReason) == '') {
                this.$message({
                  type: 'error',
                  message: "请填写自评原因"
                });
                return false;
              }else {
                let trueData = this.getAllTableData();
                this.$ajax.put(this.$api.day.DayWorkDetail.submit, {workId: this.workId, dayWorkDetails: trueData, dayPlanDetails: this.cloneTableData.tomorrow}).then(() => {
                  this.$message.success('提交成功');
                  this.reload();
                });
              }
            }
          });
        }
      },
      editActived({row, rowIndex}) {
        // if (this.editStatus == "approve" || this.editStatus == "edit") {
        //   if (row.status === 10) {
        //     //已提交 未审核禁止编辑
        //     this.allowEdit = false;
        //     this.disabled = false;
        //   } else if (row.status === 20) {
        //     //已提交 已审核 控制可编辑工作状态
        //     this.allowEdit = true;
        //     this.disabled = false;
        //   } else if (row.status === 30 || row.status === 0 || row.status === 100) {
        //     this.allowEdit = true;
        //     this.disabled = true;
        //   } else if (rowIndex === 0 || rowIndex === this.kpiLength + 1 || rowIndex === this.kpiLength + this.normalLength + 2 || rowIndex === this.kpiLength + this.normalLength + this.createLength + 3) {
        //     return false
        //   } else {
        //     this.allowEdit = false;
        //     this.disabled = false;
        //   }
        // }else {
        //   this.allowEdit = false;
        //   this.disabled = false;
        // }
        if (this.editStatus == "approve") {
          this.allowEdit = false;
          this.disabled = false;
        }else if (this.editStatus == "edit") {
          this.allowEdit = true;
          this.disabled = true;
        }else {
          this.allowEdit = false;
          this.disabled = false;
        }
        return true;
      },
      activeCellMethod({rowIndex, columnIndex}) {
        if(this.editStatus !== "edit") {
          return false
        }
        if (rowIndex === 0 || rowIndex === 2 || rowIndex === 4) {
          return false
        }
        if (columnIndex === 0 && (rowIndex === 3 || rowIndex === 5)) {
          return false
        }
        return true;
      },
      tomorrowActived() {
        if(this.editStatus !== "edit") {
          return false
        }
        return true;
      },
      move(row, rowIndex) {
        console.log(row, rowIndex);
        this.showHandle = true;
        this.nowClassify = row;
        this.classify = row.workClassify;
      },
      confirmClassify() {
        this.showHandle = false;
        this.$ajax.put(this.$api.day.DayWorkDetail.updateWorkClassify, {
          id: this.nowClassify.id,
          workClassify: this.classify,
        }).then(() => {
          this.getList();
          this.$message.success('更改工作分类成功');
        });
      },
      commit() {
        this.showCommit = true;
      },
      confirmCommit() {
        this.showCommit = false;
        this.$ajax.put(this.$api.day.dayWork.reply, {workId: this.workId,superiorEvaluationReason: this.comment}).then(() => {
          this.$message.success('反馈成功');
        });
      },
      expandKpi() {
        this.expandKpiStatus = !this.expandKpiStatus;
        if (this.expandKpiStatus) {
          this.kpi = _.cloneDeep(this.cloneKpi);
          this.cloneKpi = [];
        }else {
          this.cloneKpi = _.cloneDeep(this.kpi);
          this.kpi = [];
        }
      },
      expandNormal() {
        this.expandNormalStatus = !this.expandNormalStatus;
        if (this.expandNormalStatus) {
          this.normal = _.cloneDeep(this.cloneNormal);
          this.cloneNormal = [];
        }else {
          this.cloneNormal = _.cloneDeep(this.normal);
          this.normal = [];
        }
      },
      expandCreate() {
        this.expandCreateStatus = !this.expandCreateStatus;
        if (this.expandCreateStatus) {
          this.create = _.cloneDeep(this.cloneCreate);
          this.cloneCreate = [];
        }else {
          this.cloneCreate = _.cloneDeep(this.create);
          this.create = [];
        }
      },
      expandOther() {
        this.expandOtherStatus = !this.expandOtherStatus;
        if (this.expandOtherStatus) {
          this.other = _.cloneDeep(this.cloneOther);
          this.cloneOther = [];
        }else {
          this.cloneOther = _.cloneDeep(this.other);
          this.other = [];
        }
      },
      expandAll(){
        if (!this.expandKpiStatus) {
          this.expandKpiStatus = !this.expandKpiStatus;
          this.kpi = _.cloneDeep(this.cloneKpi);
        }
        if (!this.expandNormalStatus) {
          this.expandNormalStatus = !this.expandNormalStatus;
          this.normal = _.cloneDeep(this.cloneNormal);
        }
        if (!this.expandCreateStatus) {
          this.expandCreateStatus = !this.expandCreateStatus;
          this.create = _.cloneDeep(this.cloneCreate);
        }
        if (!this.expandOtherStatus) {
          this.expandOtherStatus = !this.expandOtherStatus;
          this.other = _.cloneDeep(this.cloneOther);
        }
      },
    },
     beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.$store.commit("common/updatePreMenu", {
          url: from.fullPath,
          name: from.meta.title
        })
      })
    },
    beforeRouteLeave (to, from, next) {
      this.$store.commit("common/updatePreMenu", null);
      next(true);
    //   // 导航离开该组件的对应路由时调用
    //   // 可以访问组件实例 `this`
    //
    },
    watch: {
      tableData: {
        handler(val) {
          // this.cloneTableData.tableData = _.cloneDeep(val);
          // if(this.row.id){
          //   this.cloneTableData.tableData[this.rowIndex].id = this.row.id;
          //   this.cloneTableData.tableData[this.rowIndex].status = this.row.status;
          // }
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ];
        },
        deep: true
      },
      tableColumnLength() {
        this.mergeCells = [
          {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},
        ];
      },
      tomorrow: {
        handler(val) {
          this.cloneTableData.tomorrow = _.cloneDeep(val);
          if(this.row.id){
            this.cloneTableData.tomorrow[this.rowIndex].id = this.row.id;
            this.cloneTableData.tomorrow[this.rowIndex].status = this.row.status;
          }
        },
        deep: true
      },
      selfEvaluationReason:{
        handler(val) {
          this.cloneTableData.selfEvaluationReason = _.cloneDeep(val);
        }
      },
      summary:{
        handler(val) {
          this.cloneTableData.summary = _.cloneDeep(val);
        }
      }
    }
  }
</script>
<style scoped lang='scss'>
  .day {
    height: 100%;
    .header {
      .day-title {
        border-right: 1px solid #eaeef4;
        padding: 0 10px;
        h2 {
          color: $--color-text-primary;
          font-size: 18px;
          font-weight: bold;
          display: inline-block;
        }
        .saveStatus{
          margin-left: 10px;
          font-size: 15px;
          color: #8e9694;
        }
      }
    }
    .container {
      margin-top: 15px;
      padding: 24px;
      flex: 1;
      .table-content{
        // overflow-y: scroll;
      }
      .kpi-content {
        overflow: auto;
        flex-grow: 1;
      }
      ::v-deep .atb-table {
        .vxe-table--header-wrapper {
          background-color: $--bg-color-complete !important;
        }
        .main-row {
          .vxe-cell {
            padding: 0;
          }
        }
      }
      .kpi-add {
        height: 47px;
        background-color: $--color-bg-table-header;
        color: $--color-primary;
        font-size: 14px;
        padding: 0 15px;
        div{
          cursor: pointer;
          span{
            margin-right: 15px;
          }
          i.fold{
            margin-right: 5px;
          }
        }
        span {
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: left;
      .sub-content{
        text-align: center;
      }
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }
  ::v-deep .el-radio-button {
    margin-right: 20px;
    margin-bottom: 15px;
    .el-radio-button__inner {
      border-radius: 20px;
      padding: 0 20px;
      width: 100%;
      line-height: 36px;
      border: 1px solid $--color-primary;
      color: $--color-primary;
    }
  }
  ::v-deep .el-radio-button.is-active .el-radio-button__inner {
    color: $--color-white;
  }
  ::v-deep .summaryText {
    .el-textarea__inner{
      padding-left: 4px !important;
    }
  }
  .program-check {
    li {
      &:not(:last-child) {
        padding-bottom: 20px;
      }
      .el-checkbox__label {
        span {
          font-weight: bold;
        }
      }
      div {
        flex-grow: 1;
        margin-left: 15px;
        p {
          color: $--color-text-primary;
          font-size: 14px;
          &.desc {
            line-height: 1.5;
          }
          &.date {
            line-height: 1;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }
  ::v-deep .vxe-table--render-default {
    .vxe-table--body-wrapper{
      overflow: hidden !important;
    }
    
  }

</style>